<template>
  <v-footer
    fixed
    app
    height="74px"
  >
    <template>
      <v-btn
        block
        large
        class="btn"
        @click="openDiningModeDialog"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
          >
            Change Dining Mode
          </v-flex>
        </v-layout>
      </v-btn>
    </template>
  </v-footer>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
    },
    methods: {
      openDiningModeDialog () {
        this.$store.dispatch('area/hidePostalCodeDialog')
        this.$store.dispatch('area/resetSelectedAreaMode')
      }
    }
  }
</script>

<style scoped>
.btn {
  margin: 10px;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupFooter.vue